import { SelectValue } from "@/components/ui/select";
import { useCustomParametersStore } from "./custom-parameters-store";
import { SelectTrigger } from "@/components/ui/select";

import { SelectContent } from "@/components/ui/select";

import { Select } from "@/components/ui/select";

import { SelectItem } from "@/components/ui/select";
import { ParameterIcon } from "./ParameterBuilderDialog/ParameterIcon";
import {
  PARAMETER_DEFAULT_VALUES,
  PARAMETER_TYPES,
} from "./ParameterBuilderDialog/constants";
import { Label } from "@/components/ui/label";
import { ComponentType } from "@/queries/models/types";
import { ParameterStore } from "@/components/ModelParameters/store/parameter-store";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";

export const ParameterTypeSelector = observer(() => {
  const store = useCustomParametersStore();
  const { currentParameter, isViewing, hasPreviousState } = store;

  const handleParameterTypeChange = (value: string) => {
    if (!hasPreviousState) {
      store.saveCurrentParameterState();
    }

    if (currentParameter) {
      currentParameter.updateParameter({
        ...PARAMETER_DEFAULT_VALUES[value as ComponentType],
        param_id: currentParameter.paramId ?? "",
        name: currentParameter.name ?? "",
        is_disabled: currentParameter.isDisabled,
        is_custom: currentParameter.isCustom,
      });

      return;
    }

    const newParameter = {
      ...PARAMETER_DEFAULT_VALUES[value as ComponentType],
      param_id: store.generateParameterId(value as ComponentType),
    };

    store.setCurrentParameter(new ParameterStore(newParameter));
  };

  const selectedType = useMemo(
    () =>
      currentParameter?.componentType
        ? PARAMETER_TYPES.find(
            (type) => type.value === currentParameter.componentType,
          )
        : undefined,
    [currentParameter?.componentType],
  );

  return (
    <>
      <Label>Parameter Type</Label>
      <Select
        onValueChange={handleParameterTypeChange}
        value={currentParameter?.componentType}
        disabled={isViewing}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select a parameter type">
            {selectedType && (
              <div className="flex items-center gap-2">
                <ParameterIcon type={selectedType.value} />
                <span>{selectedType.label}</span>
              </div>
            )}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {PARAMETER_TYPES.map((type) => (
            <SelectItem
              key={type.value}
              value={type.value}
              className="cursor-pointer"
            >
              <div className="flex items-start gap-2">
                <ParameterIcon type={type.value} />
                <div className="flex flex-col">
                  {type.label}
                  <p className="text-xs text-gray-500">{type.description}</p>
                </div>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </>
  );
});
